import { useEffect, useRef, useState } from "react";
import "./ScanBarCode.scss";
import { Button, Modal } from "antd";
import { CloseCircleOutlined } from "@ant-design/icons";
import BarcodeScannerComponent from "react-qr-barcode-scanner";
import { Quagga } from "quagga";
import { QrScanner } from "@yudiel/react-qr-scanner";
import { BarcodeReader } from "dynamsoft-javascript-barcode";
import { BarcodeScanner, TextResult } from "dynamsoft-javascript-barcode";
BarcodeReader.license = process.env.REACT_APP_LICENSE_BARCODE;
BarcodeReader.engineResourcePath = process.env.REACT_APP_RESOURCE_PATH;

const ScanBarCode = ({ isOpen = false, value = {} }) => {
  const pScanner = useRef(null);
  const elRef = useRef(null);
  const [openModal, setOpenModal] = useState(false);
  useEffect(() => {
    (async () => {
      try {
        if (elRef.current) {
          const scanner = await (pScanner.current = BarcodeScanner.createInstance());
          if (scanner.isContextDestroyed()) return;
          await scanner.setUIElement(elRef.current);
          if (scanner.isContextDestroyed()) return;
          scanner.onFrameRead = (results) => {
            for (let result of results) {
              console.log(result.barcodeText);
            }
          };
          scanner.onUniqueRead = (txt, result) => {
            value(txt);
            setOpenModal(false);
          };
          await scanner.open();
        }
      } catch (ex) {
        if (ex.message.indexOf("network connection error")) {
          console.log(ex.message);
        }
        throw ex;
      }
    })();
    return () => {
      (async () => {
        if (pScanner.current) {
          (await pScanner.current).destroyContext();
          console.log("BarcodeScanner Component Unmount");
        }
      })();
    };
  }, [openModal]);

  useEffect(() => {
    if (isOpen) {
      setOpenModal(true);
    }
  }, [isOpen]);

  return (
    <>
      <Modal
        onCancel={() => {
          setOpenModal(false);
          value(null);
        }}
        className="container-modal-barcode"
        open={openModal}
        closeIcon={<CloseCircleOutlined />}
        footer={<></>}
      >
        <div className="wrapper-barcode">
          {/* <BarcodeScannerComponent torch onUpdate={updateHandler} /> */}
          {/* <QrScanner tracker viewFinderBorder={false} onDecode={updateHandler} onError={(error) => console.log(error?.message)} />
           */}
          <div ref={elRef} className="component-barcode-scanner">
            <svg className="dce-bg-loading" viewBox="0 0 1792 1792">
              <path d="M1760 896q0 176-68.5 336t-184 275.5-275.5 184-336 68.5-336-68.5-275.5-184-184-275.5-68.5-336q0-213 97-398.5t265-305.5 374-151v228q-221 45-366.5 221t-145.5 406q0 130 51 248.5t136.5 204 204 136.5 248.5 51 248.5-51 204-136.5 136.5-204 51-248.5q0-230-145.5-406t-366.5-221v-228q206 31 374 151t265 305.5 97 398.5z"></path>
            </svg>
            <svg className="dce-bg-camera" viewBox="0 0 2048 1792">
              <path d="M1024 672q119 0 203.5 84.5t84.5 203.5-84.5 203.5-203.5 84.5-203.5-84.5-84.5-203.5 84.5-203.5 203.5-84.5zm704-416q106 0 181 75t75 181v896q0 106-75 181t-181 75h-1408q-106 0-181-75t-75-181v-896q0-106 75-181t181-75h224l51-136q19-49 69.5-84.5t103.5-35.5h512q53 0 103.5 35.5t69.5 84.5l51 136h224zm-704 1152q185 0 316.5-131.5t131.5-316.5-131.5-316.5-316.5-131.5-316.5 131.5-131.5 316.5 131.5 316.5 316.5 131.5z"></path>
            </svg>
            <div className="dce-video-container"></div>
            <div className="dce-scanarea">
              <div className="dce-scanlight"></div>
            </div>
          </div>
          <div className="holder-footer">
            <Button
              className="btn-normal"
              onClick={() => {
                setOpenModal(false);
                value(null);
              }}
            >
              {" "}
              انصراف
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ScanBarCode;
